import React from 'react'
import { createRoot } from 'react-dom/client'

import { AuthManagerInstance } from 'utils/auth/AuthManager'
import { App } from 'containers/App'

AuthManagerInstance.init().then(() => {
  const root = createRoot(document.getElementById('root'))

  root.render(<App />)
})
